import React from "react";
import { CourseFinanceForm } from "../CourseFinanceForm/CourseFinanceForm";
import { CreateCourseFinanseRequest } from "api/course-finances/courseFinancesApi";
import { PaziaLoader } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { useCourseFinance } from "api/course-finances";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { useCourseFinanceCategoryOptions } from "api/course-finances";

interface EditCourseFinanceModalProps {
  onCloseRequest: () => void;
  isOpen: boolean;
  courseId: number;
  onSubmit: (data: CreateCourseFinanseRequest) => Promise<void>;
  courseFinanceId: number | null;
}

export const EditCourseFinanceModal = ({
  onCloseRequest,
  isOpen,
  courseId,
  onSubmit,
  courseFinanceId,
}: EditCourseFinanceModalProps) => {
  const { loading, options } = useCourseFinanceCategoryOptions(false);
  if (loading || !options) return null;
  return (
    <PaziaModal id="craete-topic-modal" onCloseRequest={onCloseRequest} isOpen={isOpen} size="xl">
      <ModalPadding>
        <ModalHeader>Edytowanie płatności</ModalHeader>

        {courseFinanceId && (
          <From
            courseFinanceId={courseFinanceId}
            options={options}
            courseId={courseId}
            onCloseRequest={onCloseRequest}
            onSubmit={onSubmit}
          />
        )}
      </ModalPadding>
    </PaziaModal>
  );
};

const From = ({
  courseFinanceId,
  options,
  courseId,
  onCloseRequest,
  onSubmit,
}: {
  courseFinanceId: number;
  options: any;
  courseId: number;
  onCloseRequest: () => void;
  onSubmit: (data: CreateCourseFinanseRequest) => Promise<void>;
}) => {
  const { isLoading, courseFinance } = useCourseFinance(courseId, courseFinanceId);

  if (isLoading) return <PaziaLoader />;
  if (!courseFinance) return null;
  return (
    <CourseFinanceForm
      onSubmit={onSubmit}
      categories={options}
      courseId={courseId}
      onCancel={onCloseRequest}
      finance={courseFinance}
    />
  );
};
